import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IFormController, IPromise, IQService, IScope} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Debugger} from 'debug'
import {DokumentsigneringRessurs} from "felles/tjenester/ressurser/DokumentsigneringRessurs";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {Dialog, MdDialogController} from "../../../../tjenester/Dialog";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {DokumentRessurs} from "felles/tjenester/ressurser/DokumentRessurs";
import {AkseptertSignaturmetodeSpesifikasjon} from "../../komponenter/velgAkseptertSignaturmetode/velgAkseptertSignaturmetode";
import {DokumentsigneringTjeneste} from "../../../../../felles/tjenester/modulspesifikke/DokumentsigneringTjeneste";
import SigneringStatus = l.SigneringStatus;

const debug: Debugger = require('debug')('DokumentsignatarerDialog');
const css = require('./dokumentsignatarerDialog.scss');

export class DokumentsignatarerDialog implements MdDialogController {

    static visSendTilSigneringDialog(dokumentversjon: l.DokumentVersjonModell, $mdDialog: angular.material.IDialogService): IPromise<void> {
        return $mdDialog.show(this.dialogKonfigurasjon({dokumentversjon: dokumentversjon, modus: 'sendTilSignering'}));
    }

    static visSignatarerDialog(dokumentversjon: l.DokumentVersjonModell, $mdDialog: angular.material.IDialogService): IPromise<void> {
        return $mdDialog.show(this.dialogKonfigurasjon({dokumentversjon: dokumentversjon, modus: 'listeSignatarer'}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./dokumentsignatarerDialog.html'),
            controller: DokumentsignatarerDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            Kontekst.regNavn,
            regNavn.ng.$scope,
            regNavn.ng.$q,
            regNavn.md.$mdDialog,
            DokumentRessurs.regNavn,
            DokumentsigneringRessurs.regNavn,
            DokumentsigneringTjeneste.regNavn,
            GruppeRessurs.regNavn,
            Dialog.regNavn,
            regNavn.gettext.gettextCatalog,
            DokumentsignatarerDialog
        ]
    }

    constructor(private kontekst: Kontekst,
                private $scope: IScope,
                private $q: IQService,
                private $mdDialog: angular.material.IDialogService,
                private dokumentRes: DokumentRessurs,
                private dokumentsigneringRessurs: DokumentsigneringRessurs,
                private dokumentsigneringTjeneste: DokumentsigneringTjeneste,
                private gruppeRessurs: GruppeRessurs,
                private dialog: Dialog,
                private gettextCatalog: gettextCatalog) {
    }

    modus: 'sendTilSignering' | 'redigerSignatarer' | 'kvitteringSendTilSignering' | 'bekreftelseRedigerSignatarer' | 'listeSignatarer'; //settes via bindings
    dokumentversjon: l.DokumentVersjonModell; //settes via bindings

    modell: SigneringskjemaModell;
    signatarerKanRedigeres = true;
    feilMeldinger: string[];

    private signatarer: l.DokumentSignatarerModell;
    private gruppe: l.GruppeModell;

    signaturtype(signaturtype: l.BenyttetSigneringsmetode) {
        return this.dokumentsigneringTjeneste.signaturtypeI18nNavn(signaturtype);
    }

    enkelSignaturmetodeTilgjengelig(){
        return _.includes(this.dokumentversjon?.aksepterteSignaturmetoder, l.AkseptertSignaturmetode.enkelelektronisk);
    }

    avansertSignaturmetodeTilgjengelig(){
        return _.includes(this.dokumentversjon?.aksepterteSignaturmetoder, l.AkseptertSignaturmetode.avansertelektronisk);
    }

    gaaTilRedigerSignatarer() {
        this.initerModell()
          .then(() => {
              //oppdater modell med data fra dokument
              this.modell.aksepterteSignaturmetoder = {
                  signaturmetoder : this.dokumentversjon.aksepterteSignaturmetoder,
                  huskSignaturmetodeValg: false
              };
          })
        this.modus = 'redigerSignatarer';
    }

    lagre(skjema: IFormController) {
        if (!skjema.$valid) return;

        if (this.modus == 'sendTilSignering')
            return this.sendTilSignering();
        else
            return this.gåTilBekreftOppdaterSignatarer();
    }

    oppdaterSignatarer() {
        debug("oppdaterSignatarer, %s", this.modell.slettedeSignatarerHarSignert)
        if (this.modell.slettedeSignatarerHarSignert)
            return this.bekreftSlettingAvSignaturer()
              .then(årsak => {
                  debug("oppdaterSignatarer, årsak: %s", årsak)
                  this.modell.årsak = årsak;
                  this.utførOppdaterSignatarer();
              })

        return this.utførOppdaterSignatarer()
    }

    ferdig(){
        this.$mdDialog.hide(true);
    }

    avbryt() {
        if (this.modus == 'redigerSignatarer' || this.modus == 'bekreftelseRedigerSignatarer') {
            this.modus = 'listeSignatarer';
            return;
        }
        this.$mdDialog.cancel();
    }

    laasOppDokument() {
        this.dokumentsigneringRessurs.låsOpp(this.dokumentversjon.dokumentId).$promise
            .then(() => this.$mdDialog.hide(true));
    }

    $onInit() {
        switch (this.modus) {
            case 'sendTilSignering': this.gåTilSendTilSignering(); break;
            case 'listeSignatarer': this.gåTilListeSignatarer(); break;
        }
    }

    //hjelpemetoder

    private sendTilSignering(){
        let spesifikasjon = this.modell.somSendTilSigneringSpesifikasjon();
        return this.dokumentsigneringRessurs.sendTilSignering(this.dokumentversjon.dokumentId, spesifikasjon).$promise
            .then(validering => {
                if (validering.harFeil) {
                    this.feilMeldinger = [];
                    validering.feil.forEach(f => {
                        switch (f.feilkode) {
                            case l.SignatarValideringfeil.medlem_skjermet:
                                this.feilMeldinger.push(this.gettextCatalog.getString("{{medlemNavn}} har ikke tilgang til dokumentet og kan ikke settes til å signere", {medlemNavn: this.finnMedlemNavn(f.data.medlemId)}));
                                break;
                            case l.SignatarValideringfeil.dokument_ikke_satt: // skal ikke klare å lage disse feil via GUI
                            case l.SignatarValideringfeil.medlem_ikke_satt:
                            case l.SignatarValideringfeil.medlem_feil_gruppe:
                            default:
                                this.feilMeldinger.push("En feil har oppstått: kode=" + f.feilkode)
                                break;
                        }
                    });
                    return;
                }
                this.feilMeldinger = null;
                this.modus = 'kvitteringSendTilSignering';
                return;
            });
    }

    private gåTilBekreftOppdaterSignatarer(){
        this.modus = 'bekreftelseRedigerSignatarer';
    }

    private bekreftSlettingAvSignaturer():IPromise<string>{
        ///confirmdialog slett signatarer som har signert - kropp
        const htmlInnhold = this.gettextCatalog.getString('Du er i ferd med å fjerne signatarer som allerede har signert. Deres signatur vil bli permanent slettet.');
        var bekreft = this.$mdDialog.prompt()
          ///confirmdialog slett signatarer som har signert  - tittel
          .title(this.gettextCatalog.getString('Bekreft sletting av signaturer'))
          .htmlContent(`<div class="wt-dialog-prompt-kropp">${htmlInnhold}</div>`)
          .multiple(true)
          ///confirmdialog slett signatarer som har signert  - årsak-felt-label
          .placeholder('årsak')
          .required(true) //årsak må angis
          ///confirmdialog slett signatarer som har signert  - ok-knapp
          .ok(this.gettextCatalog.getString('Oppdater signatarer'))
          ///confirmdialog slett signatarer som har signert  - avbryt-knapp
          .cancel(this.gettextCatalog.getString('Avbryt'));
        return this.$mdDialog.show(bekreft);
    }

    private utførOppdaterSignatarer():IPromise<void>{
        let spesifikasjon = this.modell.somOppdaterSpesifikasjon();
        debug("utførOppdaterSignatarer, årsak: %j", spesifikasjon)
        return this.dokumentsigneringRessurs.oppdaterSignatarer(this.dokumentversjon.dokumentId, spesifikasjon).$promise
          .then(validering => {
              if (validering.harFeil) {
                  this.feilMeldinger = [];
                  validering.feil.forEach(f => {
                      switch (f.feilkode) {
                          case l.SignatarValideringfeil.medlem_skjermet:
                              this.feilMeldinger.push(this.gettextCatalog.getString("{{medlemNavn}} har ikke tilgang til dokumentet og kan ikke settes til å signere", {medlemNavn: this.finnMedlemNavn(f.data.medlemId)}));
                              break;
                          case l.SignatarValideringfeil.dokument_ikke_satt: // skal ikke klare å lage disse feil via GUI
                          case l.SignatarValideringfeil.medlem_ikke_satt:
                          case l.SignatarValideringfeil.medlem_feil_gruppe:
                          default:
                              this.feilMeldinger.push("En feil har oppstått: kode=" + f.feilkode)
                              break;
                      }
                  });
                  return;
              }
              this.feilMeldinger = null;
              this.ferdig();
              return;
          })
    }

    // til å vis navn i feilmelding
    private finnMedlemNavn(medlemId: string): string {
        const medlem = this.gruppe.medlemmer.filter(m => m.id === medlemId).pop();
        if (medlem) {
            return medlem.navn;
        }
        // finner ikke medlem, skriver ut id så kan vi ihvertfall se hva feilen er.
        return medlemId
    }

    private lukkDialog() {
        this.$mdDialog.cancel();
    }

    private initerModell() {
        return this.$q.all([
            this.dokumentsigneringRessurs.signatarer(this.dokumentversjon.dokumentId).$promise
                .then(signatarer => this.signatarer = signatarer),
            this.gruppeRessurs.hent(this.dokumentversjon.gruppeId).$promise
                .then(gruppe => this.gruppe = gruppe)
        ]).then(r => {
            this.modell = new SigneringskjemaModell(this.signatarer, this.gruppe);
        });
    }


    private gåTilSendTilSignering() {
        this.initerModell();
    }

    private gåTilListeSignatarer() {
        //<wm-vis-signaturstatus> laster signatarer selv
        this.signatarerKanRedigeres = this.dokumentversjon.signeringStatus == SigneringStatus.tilSignering ||
            this.dokumentversjon.signeringStatus == SigneringStatus.delvisSignert;
    }
}

class SigneringskjemaModell {
    standardSignaturmetoder: l.AkseptertSignaturmetode[];
    aksepterteSignaturmetoder: AkseptertSignaturmetodeSpesifikasjon;

    medlemmer: l.GruppeMedlemListeModell[];
    signatarer: l.GruppeMedlemListeModell[];
    nyeSignatarer: l.GruppeMedlemListeModell[] = [];
    slettedeSignatarer: l.DokumentSignatarModell[] = [];
    slettedeSignatarerHarSignert = false;
    spesifikasjon: l.SendTilSigneringSpesifikasjon;
    årsak: string; // kun benyttet ved redigering av signatarer
    private initielleSignatarer: l.DokumentSignatarModell[];

    constructor(eksisterende: l.DokumentSignatarerModell, gruppe: l.GruppeModell) {
        this.standardSignaturmetoder = gruppe.oppsett.aksepterteSignaturmetoder;
        this.medlemmer = gruppe.medlemmer;
        this.signatarer = eksisterende.signatarer.map(s => s.medlem);
        this.initielleSignatarer = eksisterende.signatarer;

        this.spesifikasjon = {
            beskjed: '',
            signatarer: [],
            signaturmetoder: this.standardSignaturmetoder,
            huskSignaturmetodeValg: false
        };
    }

    somSendTilSigneringSpesifikasjon(): l.SendTilSigneringSpesifikasjon {
        this.spesifikasjon.signaturmetoder = this.aksepterteSignaturmetoder.signaturmetoder;
        this.spesifikasjon.huskSignaturmetodeValg = this.aksepterteSignaturmetoder.huskSignaturmetodeValg;
        this.spesifikasjon.signatarer = this.signatarer.map(m => m.id);
        return this.spesifikasjon;
    }

    somOppdaterSpesifikasjon(): l.OppdaterSignatarerSpesifikasjon {
        const spesifikasjon: l.OppdaterSignatarerSpesifikasjon = {
            signatarer: this.signatarer.map(m => m.id),
            beskjed: this.spesifikasjon.beskjed,
            signaturmetoder: this.aksepterteSignaturmetoder.signaturmetoder,
            huskSignaturmetodeValg: this.aksepterteSignaturmetoder.huskSignaturmetodeValg,
            aarsak: this.årsak
        };
        return spesifikasjon;
    }

    vedSignatarerOppdatert() {
        debug('oppdaterEndringsinformasjon', this)
        const initielle = this.initielleSignatarer.map(s => s.medlem);
        this.nyeSignatarer = _.differenceBy(this.signatarer, initielle, s => s.id);
        const slettede = _.differenceBy(initielle, this.signatarer, s => s.id);
        this.slettedeSignatarer = slettede.map(medlem => _.find(this.initielleSignatarer, kandidat => kandidat.medlem.id == medlem.id));
        this.slettedeSignatarerHarSignert = this.slettedeSignatarer.some(s => s.harSignert);
    }
}
